export const sizes = {
	h35: 35,
	w250: 250,
	w300: 300,
	w500: 500,
	w650: 650,
	w750: 750,
};
